import { c as _c } from "react/compiler-runtime";
import type { StructureArticleDTO } from '@algoacademy/backend/modules/docs/endpoints/queries/get-collection-structure/output.dto';
import { DOCS_READING_STATUS_DESCRIPTIONS } from '@algoacademy/backend/modules/docs/enums';
import { Caption } from '@algoacademy/design-system/web/typography/Caption';
import { LockClosedIcon } from '@heroicons/react/24/solid';
import Link from 'next/link';
import { cn } from '@/app/_lib/utils';
import { SidebarActiveIndicatorItem } from '@/app/baza/(collection)/_components/SidebarActiveIndicatorItem';
import type { ARTICLE_STATE } from '@/app/baza/(collection)/_utils/ArticleStateContext/types';
import { ArticleStatusIcon } from './ArticleStatusIcon';
import { ArticleTitle } from './ArticleTitle';
type ArticleButtonProps = {
  article: StructureArticleDTO;
  collectionSlug: string;
  isLoggedIn: boolean;
  canManageArticle: boolean;
  isCurrent: boolean;
  status?: ARTICLE_STATE;
};
export function ArticleButton(t0) {
  const $ = _c(32);
  const {
    article,
    collectionSlug,
    isLoggedIn,
    canManageArticle,
    isCurrent,
    status
  } = t0;
  const t1 = `/baza/${collectionSlug}/${article.slug}`;
  let t2;
  if ($[0] !== canManageArticle || $[1] !== isLoggedIn || $[2] !== status) {
    t2 = (canManageArticle || isLoggedIn) && <ArticleStatusIcon status={status} isCurrent={false} />;
    $[0] = canManageArticle;
    $[1] = isLoggedIn;
    $[2] = status;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== article || $[5] !== isCurrent) {
    t3 = <ArticleTitle article={article} isCurrent={isCurrent} />;
    $[4] = article;
    $[5] = isCurrent;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== article.hasPublishedVersion || $[8] !== canManageArticle || $[9] !== status) {
    t4 = canManageArticle && <div className="flex flex-col gap-y-0.5"><Caption className={cn(article.hasPublishedVersion ? "text-contentGreen" : "text-contentTertiary")}>{article.hasPublishedVersion ? "Opublikowany" : "Nieopublikowany"}</Caption>{status != null && <Caption className="text-contentTertiary">{DOCS_READING_STATUS_DESCRIPTIONS[status]}</Caption>}</div>;
    $[7] = article.hasPublishedVersion;
    $[8] = canManageArticle;
    $[9] = status;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== canManageArticle || $[12] !== isLoggedIn || $[13] !== status) {
    t5 = !canManageArticle && isLoggedIn && status && <Caption className="text-contentTertiary">{DOCS_READING_STATUS_DESCRIPTIONS[status]}</Caption>;
    $[11] = canManageArticle;
    $[12] = isLoggedIn;
    $[13] = status;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t3 || $[16] !== t4 || $[17] !== t5) {
    t6 = <div className="flex flex-col gap-y-1 text-left">{t3}{t4}{t5}</div>;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t2 || $[20] !== t6) {
    t7 = <div className="flex items-center gap-3">{t2}{t6}</div>;
    $[19] = t2;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== article.isProtected || $[23] !== isLoggedIn) {
    t8 = article.isProtected && !isLoggedIn && <LockClosedIcon className="h-5 w-5 shrink-0 text-contentTertiary" />;
    $[22] = article.isProtected;
    $[23] = isLoggedIn;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== t1 || $[26] !== t7 || $[27] !== t8) {
    t9 = <Link href={t1} className="flex cursor-pointer items-center justify-between gap-2 rounded-lg p-2 hover:bg-backgroundHoverOverlay">{t7}{t8}</Link>;
    $[25] = t1;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] !== isCurrent || $[30] !== t9) {
    t10 = <SidebarActiveIndicatorItem active={isCurrent} layoutId="baza-module-sidebar-current-indicator">{t9}</SidebarActiveIndicatorItem>;
    $[29] = isCurrent;
    $[30] = t9;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  return t10;
}